import {FloatingField} from "@mytour/ui/form";
import type {Control, FieldErrors} from "react-hook-form";
import {z} from "zod";

export const recapEmailSchema = z.object({email: z.string().email("Adresse email invalide")});
export type RecapEmailFormData = z.infer<typeof recapEmailSchema>;

export function getRecapEmailDefaultValues(email = ""): RecapEmailFormData {
  return {email};
}

type Props = {
  control: Control<RecapEmailFormData>;
  errors: FieldErrors<RecapEmailFormData>;
  disabled: boolean;
};

export function RecapEmailForm({control, errors, disabled}: Props) {
  return (
    <FloatingField
      name="email"
      label="Adresse email"
      control={control}
      error={errors.email}
      disabled={disabled}
    />
  );
}
